import { chatSdk } from '../api/chat-sdk';
var HttpAgent = /** @class */ (function () {
    function HttpAgent(params) {
        this.baseURL = params.baseURL;
        this.requestHandler = chatSdk.getRequestHandler();
    }
    HttpAgent.prototype.get = function (urlSuffix, query) {
        if (query === void 0) { query = {}; }
        return this._request('get', urlSuffix, query);
    };
    HttpAgent.prototype.post = function (urlSuffix, data, query) {
        if (query === void 0) { query = {}; }
        return this._request('post', urlSuffix, query, { data: data });
    };
    HttpAgent.prototype.zdelete = function (urlSuffix, data) {
        return this._request('delete', urlSuffix, {}, { data: data });
    };
    HttpAgent.prototype.put = function (urlSuffix, data, query) {
        if (data === void 0) { data = {}; }
        if (query === void 0) { query = {}; }
        return this._request('put', urlSuffix, query, { data: data });
    };
    HttpAgent.prototype._request = function (method, urlSuffix, query, options) {
        if (query === void 0) { query = {}; }
        if (options === void 0) { options = {}; }
        var requestConfig = this._getRequestConfig(method, urlSuffix, query, options);
        return this.requestHandler(requestConfig);
    };
    HttpAgent.prototype._getRequestConfig = function (method, urlSuffix, query, options) {
        var url = this._getRelativeUrl(urlSuffix, query, options);
        var baseURL = this.baseURL;
        var headers = this._getHeaders(urlSuffix, query, options);
        return Object.assign({
            url: url,
            method: method,
            baseURL: baseURL,
        }, headers ? { headers: headers } : undefined, options);
    };
    return HttpAgent;
}());
export default HttpAgent;
